function tabLabel({ t }: { t: (val: string) => string }) {
  const tabList = [
    {
      id: 0,
      name: t('company.setting'),
    },
    {
      id: 1,
      name: t('board.member'),
    },
  ];
  return { tabList };
}

export default tabLabel;
